import React from 'react';

interface OrganizationFiltersProps {
  onSearchChange: (search: string) => void;
  onStatusChange: (status: string) => void;
  currentFilters: {
    search: string;
    status: string;
  };
}

const OrganizationFilters: React.FC<OrganizationFiltersProps> = ({
  onSearchChange,
  onStatusChange,
  currentFilters,
}) => {
  return (
    <div className="flex flex-wrap gap-4">
      <div className="flex-1 min-w-[200px]">
        <input
          type="text"
          placeholder="Search organizations..."
          value={currentFilters.search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full px-4 py-2 rounded-xl bg-light-card dark:bg-dark-card border border-light-border dark:border-dark-border text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-400"
        />
      </div>
      <div className="min-w-[150px]">
        <select
          value={currentFilters.status}
          onChange={(e) => onStatusChange(e.target.value)}
          className="w-full px-4 py-2 rounded-xl bg-light-card dark:bg-dark-card border border-light-border dark:border-dark-border text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-400 cursor-pointer"
        >
          <option value="">All Statuses</option>
          <option value="active">Active</option>
          <option value="disabled">Disabled</option>
          <option value="suspended">Suspended</option>
        </select>
      </div>
    </div>
  );
};

export default OrganizationFilters;